<template>
  <div class="gain">
    <section-heading>What is the Gain Livinar?</section-heading>
      <b-container>
        <b-row>
          <b-col cols="12">
            <div class="gain__info">
              <p class="gain__text">
                Colloquium - The Gain Livinar is the world’s only Purpose driven and result-oriented 90 day engagement system with personal hand-holding to gain tangible results in a time-bound and fool-proof manner.
              </p>
            </div> 
          </b-col>
        </b-row>
      </b-container>
      <div class="gain__imageBox">
        <div class="gain__imageItem" v-for="(imageItem,index) in gainLivinarImages" :key="index">
          <img :src="imageItem" class="img-fluid"/>
        </div>
      </div> 
      <ab-flaps></ab-flaps>
  </div>
</template>
<script>
import Heading from '../Shared/Heading';
import gain1 from '../../assets/image/about/gain-1.png';
import gain2 from '../../assets/image/about/gain-2.png';
import gain3 from '../../assets/image/about/gain-3.png';
import ABFlaps from './AB-Flaps';

export default {
  data(){
    return {
      gainLivinarImages:[
        gain1,
        gain2,
        gain3
      ]
    }
  },
  components:{
    'section-heading':Heading,
    'ab-flaps': ABFlaps
  }
}
</script>
<style scoped>
.gain__info{
  padding:25px 46px;
  text-align: center;
}

.gain__text{
  font-size: 22px;
  font-family: 'Seravek-Light';
  color: var(--para-color);
  margin-bottom: 0;
}

.gain__imageBox{
  display: flex;
  justify-content: center;
  margin-bottom: 47px;
}

.gain__imageItem{
  align-self: center;
}

/* Mobiles (Portrait) */
@media (min-width: 320px) and (max-width: 480px) {
  .gain__info{
    padding: 20px 4%;
  }

  .gain__imageBox{
    width: 90%;
    margin: 0 auto;
    margin-bottom: 35px;
  }
}

/* Low Resolution Tablets, Mobiles (Landscape) */
@media (min-width: 481px) and (max-width: 767px) {
  .gain__text{
    font-size: 21px;
  }

  .gain__info{
    padding: 25px 0;
  }

  .gain__imageBox{
    width: 90%;
    margin: 0 auto;
    margin-bottom: 35px;
  }
}
/* Tablets, Ipads (portrait) */
@media (min-width: 768px) and (max-width: 1024px) {
  .gain__imageBox{
    width: 90%;
    margin: 0 auto;
    margin-bottom: 35px;
  }
  
}
</style>